import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { routeToSearch } from '../actions/route';

class SearchBox extends React.Component {
    static propTypes = {
        routeToSearch: PropTypes.func.isRequired,
        contentId: PropTypes.number,
    };

    state = {
        searchText: '',
    };

    handleChange = e => {
        this.setState({ searchText: e.target.value });
    };

    handleFormSubmit = e => {
        e.preventDefault();

        if (this.state.searchText !== '') {
            this.props.routeToSearch(
                this.state.searchText,
                this.props.contentId
            );
        }

        this.setState({ searchText: '' });
    };

    renderForm = () => {
        const { searchText } = this.state;
        const searchClasses = classNames({ active: searchText != '' });

        return (
            <form id="search-form" action="#" onSubmit={this.handleFormSubmit}>
                <fieldset>
                    <legend className="aural">Search Form</legend>

                    <label
                        htmlFor="search"
                        className="aural"
                        aria-hidden="true"
                    >
                        Search
                    </label>

                    <input
                        type="text"
                        id="search"
                        value={this.state.searchText}
                        title="Search"
                        className={searchClasses}
                        name="search_text"
                        placeholder="Search"
                        aria-label="Search"
                        onChange={this.handleChange}
                    />

                    <button
                        type="submit"
                        tabIndex={searchText ? 0 : -1}
                        aria-label="submit"
                    >
                        <i className="cl-icon cl-icon-search"></i>
                    </button>
                </fieldset>
            </form>
        );
    };

    render() {
        return (
            <div className="search-container">
                <div className="js-search search">
                    <div className="search-container" role="search">
                        {this.renderForm()}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    null,
    {
        routeToSearch,
    }
)(SearchBox);



// WEBPACK FOOTER //
// ./src/components/searchbox.jsx